<template>
  <div class="fcf-kyc">
    <b-collapse class="panel" :open.sync="isOpen">
      <panel-heading slot="trigger" :title="'KYC Documents'" :edit-not-allowed="editNotAllowed"/>

      <div class="panel-block fcf-kyc__content">
        <div class="fcf-kyc__row fcf-kyc__row--header fcf-kyc__row--1" v-if="!editNotAllowed">
          <div class="buttons is-right">
            <a class="button"
              :href="kycLink"
              target="_blank"
              v-if="kycLink"
            >
              <b-icon icon="web"/>
              <span>KYC Form</span>
            </a>            
            <button class="button" @click="updateData">
              <b-icon icon="refresh"/>
              <span>Refresh data from KYC</span>
            </button>
          </div>
        </div>
        <div class="fcf-kyc__row fcf-kyc__row--1">
          <div class="subtitle">KYC Documents received or outstanding</div>
        </div>

        <template v-for="(doc, idx) in localKycData.kycDocuments">
          <div class="fcf-kyc__row fcf-kyc__row--data" :key="`${idx}`">
            <div class="fcf-kyc__cell">
              {{doc.docDesc.replace(' {0}', '')}}{{doc.name ? ` for ${doc.name}` : ''}}
            </div>
            <div class="fcf-kyc__cell">
              <b-field>

                <b-radio-button v-model="doc.status"
                  :native-value="0"
                  :disabled="editNotAllowed"
                  type="is-danger">
                  <b-icon icon="close"/>
                  <span>No</span>
                </b-radio-button>

                <b-radio-button v-model="doc.status"
                  :native-value="10"
                  :disabled="editNotAllowed"
                  type="is-warning">
                  <b-icon icon="check"/>
                  <span>Copy received</span>
                </b-radio-button>

                <b-radio-button v-model="doc.status"
                  :native-value="20"
                  :disabled="editNotAllowed"
                  type="is-success">
                  <b-icon icon="check"/>
                  <span>Original or certified copy received</span>
                </b-radio-button>

              </b-field>
            </div>
          </div>
        </template>

        <div class="fcf-kyc__row fcf-kyc__row--1" v-if="!editNotAllowed">
          <b-collapse :open.sync="showAddKycDocument">
            <button class="button is-primary is-outlined" slot="trigger">Add document</button>
            <div class="box">
              <b-field grouped group-multiline>
                <b-field label="Document Name" horizontal expanded>
                  <b-input v-model="documentName" placeholder="Input document name"/>
                </b-field>

                <b-field label="Status" horizontal>
                  <b-select placeholder="Select a document status" v-model.number="documentStatus">
                    <option value="0">No</option>
                    <option value="10">Copy received</option>
                    <option value="20">Originals or certified copy received</option>
                  </b-select>
                </b-field>

                <b-field>
                  <button class="button" @click="addKycDocument">Add</button>
                </b-field>
              </b-field>
            </div>
          </b-collapse>
        </div>

        <div class="fcf-kyc__row fcf-kyc__row--data">
          <div class="fcf-kyc__cell">Is the KYC system up to date and an accurate record of all KYC for this matter?</div>
          <div class="fcf-kyc__cell fcf-kyc__cell--center">
            <div class="field">
              <b-checkbox v-model="localKycData.kycUpdated" :disabled="editNotAllowed"/>
            </div>
          </div>
        </div>
        <div class="fcf-kyc__row fcf-kyc__row--data">
          <div class="fcf-kyc__cell">Are there any outstanding KYC documents?</div>
          <!-- <div class="fcf-kyc__cell">Has the KYC system been marked as completed?</div> -->
          <div class="fcf-kyc__cell fcf-kyc__cell--center">
            <b-field position="is-centered">
              <!-- <b-checkbox v-model="localKycData.kycCompleted" :disabled="editNotAllowed"/> -->
              <!-- <b-checkbox v-model="localKycData.kycHasOutstanding" :disabled="editNotAllowed"/> -->
              <b-radio-button v-model="localKycData.kycHasOutstanding"
                :disabled="editNotAllowed"
                :native-value="false"
                type="is-success"
              >
                  <b-icon icon="close"></b-icon>
                  <span>No</span>
              </b-radio-button>

              <b-radio-button v-model="localKycData.kycHasOutstanding"
                :disabled="editNotAllowed"
                :native-value="true"
                type="is-danger"
              >
                  <b-icon icon="check"></b-icon>
                  <span>Yes</span>
              </b-radio-button>
            </b-field>
          </div>
        </div>

      </div>
    </b-collapse>
  </div>
</template>

<script>
import PanelHeading from '@/components/PanelHeading'

export default {
  name: 'FcfKyc',
  props: [
    'kycData',
    'jobNumber',
    'editNotAllowed'
  ],
  components: {
    PanelHeading
  },
  data () {
    return {
      localJobNumber: this.jobNumber,
      localKycData: this.kycData,
      isOpen: true,
      showAddKycDocument: false,
      documentName: null,
      documentStatus: 0
    }
  },
  watch: {
    jobNumber () {
      this.localJobNumber = this.jobNumber
    },
    kycData () {
      this.localKycData = this.kycData
    }
  },
  computed: {
    kycLink () {
      if (!this.localKycData.kycFormId) return
      return `${process.env.VUE_APP_KYC_URL}/${this.localKycData.kycFormId}`
    }
  },
  methods: {
    // onRowClick (key) {
    //   console.log('rowclick', key)
    //   this.$set(this.localKycData, key, !this.localKycData[key])
    //   this.$emit('form-changed')
    // },
    addKycDocument () {
      const data = {
        docDesc: this.documentName,
        status: this.documentStatus
      }
      if (!this.localKycData.hasOwnProperty('kycDocuments')) {
        this.localKycData.kycDocuments = []
      }
      this.localKycData.kycDocuments.push(data)
      this.documentName = null
      this.documentStatus = null
      this.showAddKycDocument = false
      this.changed = true
    },
    updateData () {
      this.$emit('update-kyc-data')
    }
    // onKycLinkClick () {
    //   window.open(this.kycLink, '_blank')
    // }
  }
}
</script>

<style scoped>

.fcf-kyc__content {
  display: grid;
  grid-column: 1/-1;
  grid-gap: 1em;
  grid-template-columns: 1fr;
}

.fcf-kyc__row {
  align-items: center;
  display: grid;
  grid-gap: 1em;
  grid-template-columns: 1fr 1fr;
  padding-bottom: 0.5em;
  padding-top: 0.5em;
}

.fcf-kyc__row--data:hover {
  background-color: #fafafa;
  /* cursor: pointer; */
}

.fcf-kyc__row--header {
  font-size: 1.2em;
  font-weight: bold;
}

.fcf-kyc__row--1 {
  grid-template-columns: 1fr;
}

.fcf-kyc__cell {}
.fcf-kyc__cell--center {
  text-align: center;
}

.panel-block {
  display: grid;
  grid-gap: 1em;
}

a.button {
  color: #167df0;
}

</style>

<style>
.b-radio.radio[disabled] {
  color: #363636;
  opacity: 1;
}
</style>